import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import Pcarousel from "../ProjectDetailsCarousel/Pcarousel";
import Footer from "../Footer";
import MobileFooter from "../../Mobile/Footer";
import TabletFooter from "../../Tablet/Footer";
import NavBar from "../NavBar";
import MobileNavBar from "../../Mobile/NavBar";
import TabNavBar from "../../Tablet/NavBar";
import "../ProjectDetailsCarousel/PortfolioDetailPage.css";
import { useParams } from 'react-router-dom';

function PortfolioDetailPage(){
    let { projectid } = useParams();
    return (
        <>
            <div className="desktop-only">
                <NavBar/>
            </div>
            <div className="mobile-only">
                <MobileNavBar/>
            </div>
            <div className="tablet-only">
                <TabNavBar/>
            </div>
                <Pcarousel projectid = {projectid}/>
            <div className="desktop-only">
                <Footer/>
            </div>
            <div className="mobile-only">
                <MobileFooter/>
            </div>
            <div className="tablet-only">
                <TabletFooter/>
            </div>
        </>
    )
}

export default PortfolioDetailPage;